import styled from 'styled-components';

const LineHeader = styled.h2`
  font-size: 20px;
  margin-bottom: 3px;
  font-family: Montserrat, sans-serif;
`;

export default LineHeader;
